import React from "react";
import './liveClasses.scss';
import EmptyState from "../../shared/components/EmptyState";

const LiveClasses = () =>{
    return(
        <div className='page-view'>
            <EmptyState text={'Coming soon...'}/>
        </div>
    )
}

export default LiveClasses;
